export default {
  enterprisesWithPartners: (state) => state.preferredPartners.enterprisesWithPartners,
  getPreferredPartnersAutoComplete: (state) => state.preferredPartners.partnersListAutoComplete,
};
